import type { Components, Theme } from "@mui/material/styles";

export const MuiCheckbox: Components<Theme>["MuiCheckbox"] = {};
